import React from 'react';

import NewContentSvg from '../images/new-content-pages.svg';
import { SLIDE_LIST } from '../maps';

const show = (index) => {
  for (const [idx, slide] of SLIDE_LIST.entries()) {
    if (index === idx) {
      return slide.newContent;
    }
  }
  return '';
};

export function showNewContentBanner() {
  const lastDate = new Date(process.env.HIGHLIGHT_NEW_CONTENT);
  return lastDate > new Date();
}

export function NewContent({ index }) {
  if (!showNewContentBanner()) {
    return '';
  }

  if (!show(index)) {
    return '';
  }

  return <NewContentSvg className="Container__new-content" />;
}
